//export const URL = 'http://localhost:3000/';
export const URL = 'https://spray.care/';
